module.exports = __webpack_public_path__ + "img/logo_text_white.651609d3.png";